var _excluded = ["children", "toLabel"];

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import Downshift from "downshift";
import * as React from "react";
import { Manager } from "react-popper";
import Box from "../Box";
import theme from "../theme";
import ComboboxMenu from "./ComboboxMenu";
import ComboboxTrigger from "./ComboboxTrigger";
import { jsx as ___EmotionJSX } from "@emotion/core";

var Combobox = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Combobox, _React$Component);

  function Combobox() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      menuPlacement: "bottom-start"
    };

    _this.onStateChange = function (state, stateAndHelpers) {
      var _this$props = _this.props,
          onStateChange = _this$props.onStateChange,
          onOpen = _this$props.onOpen,
          onClose = _this$props.onClose;

      if (onStateChange) {
        onStateChange(state, stateAndHelpers);
      }

      if (state.isOpen === true) {
        if (onOpen) {
          onOpen();
        } // When the search ComboboxTriggerInput is clicked to open the
        // ComboboxMenu, we want to select all of the text to allow the user to
        // quickly search for a new item by simply pressing backspace.


        if (state.type === "click" && _this.focusableNode && _this.focusableNode instanceof HTMLInputElement) {
          _this.focusableNode.setSelectionRange(0, 9999);
        }
      }

      if (state.isOpen === false && onClose) {
        onClose();
      }
    };

    _this.onMenuPlacementChange = function (newMenuPlacement) {
      if (newMenuPlacement != null && newMenuPlacement !== _this.state.menuPlacement) {
        _this.setState({
          menuPlacement: newMenuPlacement
        });
      }
    };

    _this.setFocusableNode = function (node) {
      _this.focusableNode = node;
    };

    _this.renderWithDownshiftProps = function (downshiftProps) {
      var _ref = _this.props,
          allowClear = _ref.allowClear,
          children = _ref.children,
          placeholder = _ref.placeholder,
          disabled = _ref.disabled,
          disableSearch = _ref.disableSearch,
          loading = _ref.loading,
          gray = _ref.gray,
          requireAction = _ref.requireAction,
          toLabel = _ref.toLabel,
          toValue = _ref.toValue,
          renderSelected = _ref.renderSelected;

      var comboboxChildrenProps = _extends({}, downshiftProps, {
        menuPlacement: _this.state.menuPlacement,
        toLabel: toLabel,
        toValue: toValue
      });

      return ___EmotionJSX(Box, _extends({
        position: "relative",
        zIndex: downshiftProps.isOpen ? theme.zIndices.dropdown : 1
      }, downshiftProps.getRootProps()), ___EmotionJSX(ComboboxTrigger, _extends({}, comboboxChildrenProps, {
        allowClear: allowClear,
        placeholder: placeholder,
        disabled: disabled,
        disableSearch: disableSearch,
        loading: loading,
        gray: gray,
        requireAction: requireAction,
        focusableRef: _this.setFocusableNode,
        renderSelected: renderSelected
      })), ___EmotionJSX(ComboboxMenu, _extends({
        loading: loading,
        onMenuPlacementChange: _this.onMenuPlacementChange
      }, comboboxChildrenProps), children(comboboxChildrenProps)));
    };

    return _this;
  }

  var _proto = Combobox.prototype; // eslint-disable-next-line camelcase

  _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(_ref2) {
    var isOpen = _ref2.isOpen; // istanbul ignore next

    this.justOpened = !this.props.isOpen && isOpen;
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    // istanbul ignore next
    if (this.justOpened && this.focusableNode) {
      this.focusableNode.focus();
    }
  };

  _proto.render = function render() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var _ref3 = this.props,
        children = _ref3.children,
        toLabel = _ref3.toLabel,
        props = _objectWithoutPropertiesLoose(_ref3, _excluded);

    return ___EmotionJSX(Manager, null, ___EmotionJSX(Downshift, _extends({}, props, {
      itemToString: toLabel,
      onStateChange: this.onStateChange
    }), this.renderWithDownshiftProps));
  };

  return Combobox;
}(React.Component);

Combobox.defaultProps = {
  allowClear: false,
  placeholder: "Select…",
  disabled: false,
  disableSearch: false,
  loading: false,
  isOpen: false,
  gray: false,
  requireAction: false,
  toLabel: function toLabel(item) {
    return String(item);
  },
  toValue: function toValue(item) {
    return String(item);
  },
  renderSelected: function renderSelected(_ref4) {
    var selectedItem = _ref4.selectedItem,
        toLabel = _ref4.toLabel;
    return toLabel(selectedItem);
  }
};
export { Combobox as default };